export default {
	onStartCropViewPage: 'onStartCropViewPage',
	onHelpButtonClick: 'onHelpButtonClick',
	onTradeDetailviewpage: 'onTradeDetailviewpage',
	onContacttoSellButtonClick: 'onContacttoSellButtonClick',
	onScrollCropViewPage: 'onScrollCropViewPage',
	onTradeServiceablePage: 'onTradeServiceablePage',
	onEndCropViewPage: 'onEndCropViewPage',
	onStartCropDetailPage: 'onStartCropDetailPage',
	onScrollCropDetailViewPage: 'onScrollCropDetailViewPage',
	onBackButtonClick: 'onBackButtonClick',
	onBrokerageButtonClick: 'onBrokerageButtonClick',
	onFincostButtonClick: 'onFincostButtonClick',
	onNetpriceButtonClick: 'onNetpriceButtonClick',
	onContactToSellButtonClick: 'onContactToSellButtonClick',
	//onEndCropViewPage: 'onEndCropViewPage'
	onSelectCrop: 'onSelectCrop',
	onCropFilterCloseButtonClick: 'onCropFilterCloseButtonClick',
	onCropFilterApplyButtonClick: 'onCropFilterApplyButtonClick',
	onSelectLocation: 'onSelectLocation',
	onSelectLocationCloseFilterButtonClick:
		'onSelectLocationCloseFilterButtonClick',
	onLocationFilterApplyButtonClick: 'onLocationFilterApplyButtonClick',
	onSelectVarity: 'onSelectVarity',
	onVarityFilterCloseButtonClick: 'onVarityFilterCloseButtonClick',
	onclickpricecard: 'onclickpricecard',
	ontradenonserviceablehelpbuttonclicked:
		'ontradenonserviceablehelpbuttonclicked',
	ontradenonserviceablepage: 'ontradenonserviceablepage',
	onPaymentBuyersTermsButtonClick: 'onPaymentBuyersTermsButtonClick',
	onPaymentGRNTermsButtonClick: 'onPaymentGRNTermsButtonClick',
	onPaymentBuyersTermsInfoButtonClick: 'onPaymentBuyersTermsInfoButtonClick',
	onPaymentGRNTermsInfoButtonClick: 'onPaymentGRNTermsInfoButtonClick',
	onCreateSaudaScreenCloseButtonClick: 'onCreateSaudaScreenCloseButtonClick',
	onPaymentTermsInfoBottomSheetCloseButtonClick:
		'onPaymentTermsInfoBottomSheetCloseButtonClick',
	onSaudaRequestScreenBrokerageInfoButtonClick:
		'onSaudaRequestScreenBrokerageInfoButtonClick',
	onSaudaRequestFincostinfoButtonClick: 'onSaudaRequestFincostinfoButtonClick',
	onSaudaRequestNetpriceInfoButtonClick: 'onSaudaRequestNetpriceInfoButtonClick',
	onTermsSubmissionButtonClick: 'onTermsSubmissionButtonClick',
	onSaudaProceedSubmissionButtonClick: 'onSaudaProceedSubmissionButtonClick',
	onConfirmSaudaRequestSubmissionButtonClick:
		'onConfirmSaudaRequestSubmissionButtonClick',
	onOrderDetailsNetPriceInfoButtonClick: 'onOrderDetailsNetPriceInfoButtonClick',
	onCallNowButtonClick: 'onCallNowButtonClick',
	onChatWithUsButtonClick: 'onChatWithUsButtonClick',
	onCancelSaudaRequestButtonClick: 'onCancelSaudaRequestButtonClick',
	onCancelSaudaRequestCloseButtonClick: 'onCancelSaudaRequestCloseButtonClick',
	onConfirmCancelSaudaRequestButtonClick:
		'onConfirmCancelSaudaRequestButtonClick',
	onRejectPOButtonClick: 'onRejectPOButtonClick',
	onAcceptPOButtonClick: 'onAcceptPOButtonClick',
	onCancelButtonClick: 'onCancelButtonClick',
	onAcceptCancelButtonClick: 'onAcceptCancelButtonClick',
	onAcceptPOCancelButtonClick: 'onAcceptPOCancelButtonClick',
	onMySaudasButtonClick: 'onMySaudasButtonClick',
	onOpenSaudasButtonClick: 'onOpenSaudasButtonClick',
	onClosedSaudasButtonClick: 'onClosedSaudasButtonClick',
	onMySaudasCardButtonClick: 'onMySaudasCardButtonClick',
	onMySaudasBackButtonClick: 'onMySaudasBackButtonClick',
	onSaudaStatusClicked: 'onSaudaStatusClicked',
	onSaudaStatusCloseButtonClicked: 'onSaudaStatusCloseButtonClicked',
	onSaudaStatusFilterButtonClick: 'onSaudaStatusFilterButtonClick',
	onInputQuantityBoxClick: 'onInputQuantityBoxClick',
	onRequestSaudaButtonClick: 'onRequestSaudaButtonClick',
	onRequestSaudaProceedButtonClick: 'onRequestSaudaProceedButtonClick',
	OnAcceptPOCheckboxClick: 'OnAcceptPOCheckboxClick',
	onSaudaDetailsScreenStart: 'onSaudaDetailsScreenStart',
	onSaudaDetailsScreenEnd: 'onSaudaDetailsScreenEnd',
	OnViewPOReceiptClick: 'OnViewPOReceiptClick',
	onDebitNoteClick: 'onDebitNoteClick',
	onDebitNoteDocumentDownloadClick: 'onDebitNoteDocumentDownloadClick',
	onStartMySaudasScreen: 'onStartMySaudasScreen',
	onEndMySaudasScreen: 'onEndMySaudasScreen',
	onPaymentDetailsGotItButtonClick: 'onPaymentDetailsGotItButtonClick',
	onPaymentDetailsTaptoCopyButtonClick: 'onPaymentDetailsTaptoCopyButtonClick',
	onPaymentDetailsCloseButtonClick: 'onPaymentDetailsCloseButtonClick',
	OnTruckDetailsViewPaymentDetailsCardClick:
		'OnTruckDetailsViewPaymentDetailsCardClick',
	onTradeListingRequestSaudaButtonClick: 'onTradeListingRequestSaudaButtonClick',

	// Trade screen / Create order flow events
	OnTradeScreenBannerClick: 'OnTradeScreenBannerClick',
	OnTradeScreenEducationalBottomsheetview:
		'OnTradeScreenEducationalBottomsheetview',
	OnTradeScreenEducationalBottomsheetclick:
		'OnTradeScreenEducationalBottomsheetclick',
	OnTradeScreenBuyerSelected: 'OnTradeScreenBuyerSelected',
	OnTradeScreenCropSelected: 'OnTradeScreenCropSelected',
	OnTradeScreenBrokerSelected: 'OnTradeScreenBrokerSelected',
	OnBuyerPodoc: 'OnBuyerPodoc',
	OnTradeScreenProceedButtonClick: 'OnTradeScreenProceedButtonClick',
	OnTradeConfirmScreenClicked: 'OnTradeConfirmScreenClicked',

	onLocationAccessPopup: 'onLocationAccessPopup',
	onChangeTradeLocationButton: 'onChangeTradeLocationButton',
	onDispatchedWeightInputBoxClick: 'onDispatchedWeightInputBoxClick',
	onTruckNumberInputBoxClick: 'onTruckNumberInoutBoxClick',
	onNumberOfBagInputBoxClick: 'onNumberOfBagInputBoxClick',
	onTruckDriverMobileNumberInputBoxClick:
		'onTruckDriverMobileNumberInputBoxClick',
	onUploadSaudaDocumentButtonClick: 'onUploadSaudaDocumentButtonClick',
	onCreateDispatchSubmitButtonClick: 'onCreateDispatchSubmitButtonClick',
	onDispatchTruckButtonClick: 'onDispatchTruckButtonClick',
	onTruckNumberButtonClick: 'onTruckNumberButtonClick	',
	OnTruckDetailsPaymentDetailsButtonClick:
		'OnTruckDetailsPaymentDetailsButtonClick',
	onCreateDispatchBackButton: 'onCreateDispatchBackButton',
	onContinueDispatchButtonClick: 'onContinueDispatchButtonClick',
	onCancelDispatchButtonClick: 'onCancelDispatchButtonClick',
	onDocumentUploadButtonClick: 'onDocumentUploadButtonClick',
	onUploadedDocumentButtonClick: 'onUploadedDocumentButtonClick',
	onAddMoreFilesButtonClick: 'onAddMoreFilesButtonClick',
	onDoneButtonClick: 'onDoneButtonClick',
	onContinueUploadingButtonClick: 'onContinueUploadingButtonClick',
	onCancelUploadingButtonClick: 'onCancelUploadingButtonClick',
	onDeleteButtonClick: 'onDeleteButtonClick',
	onStartCommunityHomeScreen: 'onStartCommunityHomeScreen',
	onCommunityCategoryPageButtonClick: 'onCommunityCategoryPageButtonClick',
	onEndCommunityHomeScreen: 'onEndCommunityHomeScreen',
	onCommunityBackButtonClick: 'onCommunityBackButtonClick',
	onStartCommunityDetailedPage: 'onStartCommunityDetailedPage',
	onClapButtonClick: 'onClapButtonClick',
	onCommunityDetailedDisclaimerButtonClick:
		'onCommunityDetailedDisclaimerButtonClick',
	onCommentClapClick: 'onCommentClapClick',
	onCommentMoreRepliesClick: 'onCommentMoreRepliesClick',
	onCommentViewLessClick: 'onCommentViewLessClick',
	onCommunityRecommendedCardClick: 'onCommunityRecommendedCardClick',
	onCommentInputBoxClick: 'onCommentInputBoxClick',
	/* App side login flow moengage events starts here*/
	onPrivacyPolicyButtonClick: 'onPrivacyPolicyButtonClick',
	onTermsConditionsButtonClick: 'onTermsConditionsButtonClick',
	onSGNOTPSubmittedButtonClick: 'onSGNOTPSubmittedButtonClick',
	/* App side login flow moengage events ends here*/

	/* homescreen pwa events start */
	onWebHomeScreenChangeProfileClick: 'onWebHomeScreenChangeProfileClick',
	onWebProfileSelectionClick: 'onWebProfileSelectionClick',
	onWebProfileSelectionCloseButtonClick: 'onWebProfileSelectionCloseButtonClick',
	onWebDistributorBottomSheetDownloadAppButtonClick:
		'onWebDistributorBottomSheetDownloadAppButtonClick',
	onWebDistributorBottomSheetNotNowButtonClick:
		'onWebDistributorBottomSheetNotNowButtonClick',
	onWebCropAdvisoryBottomSheetDownloadAppButtonClick:
		'onWebCropAdvisoryBottomSheetDownloadAppButtonClick',
	onWebCropAdvisoryBottomSheetNotNowButtonClick:
		'onWebCropAdvisoryBottomSheetNotNowButtonClick',
	onWebRakeBottomSheetDownloadAppButtonClick:
		'onWebRakeBottomSheetDownloadAppButtonClick',
	onWebRakeBottomSheetNotNowButtonClicked:
		'onWebRakeBottomSheetNotNowButtonClicked',
	onWebBahiKhataBottomSheetDownloadAppButtonClick:
		'onWebBahiKhataBottomSheetDownloadAppButtonClick',
	onWebBahiKhataBottomSheetNotNowButtonClick:
		'onWebBahiKhataBottomSheetNotNowButtonClick',
	onWebSMSBottomSheetDownloadAppButtonClick:
		'onWebSMSBottomSheetDownloadAppButtonClick',
	onWebSMSBottomSheetNotNowButtonClick: 'onWebSMSBottomSheetNotNowButtonClick',
	onWebQuizBottomSheetNotNowButtonClick: 'onWebQuizBottomSheetNotNowButtonClick',
	onWebQuizBottomSheetDownloadAppButtonClick:
		'onWebQuizBottomSheetDownloadAppButtonClick',
	/* homescreen pwa events end */

	/* Moengage home screen native events */
	onHomeScreenSmsFeatureButtonClick: 'onHomeScreenSmsFeatureButtonClick',
	onRakeFeatureClick: 'onRakeFeatureClick',
	onHomeScreenHelpButtonClick: 'onHomeScreenHelpButtonClick',
	onMyProfileButtonClick: 'onMyProfileButtonClick',
	onAddFarmerButtonClick: 'onAddFarmerButtonClick',
	onWeatherCardShareButtonClick: 'onWeatherCardShareButtonClick',
	onQuizBannerClick: 'onQuizBannerClick',
	onStartHomeScreen: 'onStartHomeScreen',
	onBahiKhataButtonClicked: 'onBahiKhataButtonClicked',
	/* Moengage home screen native events */

	/* broker code events start */
	onBrokerCodeInputBoxButttonClick: 'onBrokerCodeInputBoxButttonClick',
	onBrokerCodeApplyButtonClick: 'onBrokerCodeApplyButtonClick',
	onBrokerCodeCloseButtonClick: 'onBrokerCodeCloseButtonClick',
	/* broker code events end */

	/* FAQ Question Screen events start */
	onStartHelpFaqScreen: 'onStartHelpFaqScreen',
	onFaqButtonClick: 'onFaqButtonClick',
	/* FAQ Question Screen events end */

	/* FAQ Answer Screen events start */
	onStartFaqDetailedScreen: 'onStartFaqDetailedScreen',
	onHelpWhatsappButtonClick: 'onHelpWhatsappButtonClick',
	/* FAQ Answer Screen events end */

	RAKE_LAUNCHED: 'RAKE_LAUNCHED',
	MORE_CARD_EXPLORED: 'MORE_CARD_EXPLORED',
	RAKE_CARD_CLICKED: 'RAKE_CARD_CLICKED',
	onRakeListTypeSegmentChange: 'onRakeListTypeSegmentChange',

	/* rake detail screen events start */
	onDetailRakeScreenLaunch: 'onDetailRakeScreenLaunch',
	/* rake detail screen events end  */

	/* Event for doucment trade document upload */
	techEventFileSizeUploaded: 'techEventFileSizeUploaded',

	/* my profile events start */
	onRateAppButtonClick: 'onRateAppButtonClick',
	onLogoutButtonClick: 'onLogoutButtonClick',
	onEndLogoutConfirmationScreen: 'onEndLogoutConfirmationScreen',
	onChooseLanguageButtonClick: 'onChooseLanguageButtonClick',
	onMyProfileHelpButtonClick: 'onMyProfileHelpButtonClick',
	onMyProfileEditProfileButtonClick: 'onMyProfileEditProfileButtonClick',
	onEndMyProfileScreen: 'onEndMyProfileScreen',
	onStartMyProfileScreen: 'onStartMyProfileScreen',
	/* my profile events end */
	ADD_FARMER: 'ADD_FARMER',
	NEW_MANNUAL_ADD_FARMER_CLICKED: 'NEW_MANNUAL_ADD_FARMER_CLICKED',
	NEW_MANNUAL_FAMER_ADDED: 'NEW_MANNUAL_FAMER_ADDED',
	onAddFarmerManuallyButtonClick: 'onAddFarmerManuallyButtonClick',
	onAddFarmerSearchInputBoxClick: 'onAddFarmerSearchInputBoxClick',
	onAddFarmerSelectFarmerCheckboxClick: 'onAddFarmerSelectFarmerCheckboxClick',
	onSubmitFarmerListButtonClick: 'onSubmitFarmerListButtonClick',
	onViewMyFarmersButtonClick: 'onViewMyFarmersButtonClick',
	onMyFarmersDeleteButtonClick: 'onMyFarmersDeleteButtonClick',
	onDeleteFarmerButtonClick: 'onDeleteFarmerButtonClick',
	onDeleteFarmerCancelButtonClick: 'onDeleteFarmerCancelButtonClick',
	onDeleteFarmerCrossButtonClick: 'onDeleteFarmerCrossButtonClick',
	onAddFarmerManuallySubmitButtonClick: 'onAddFarmerManuallySubmitButtonClick',
	onAddFarmerManuallyFarmerNameInputBoxClick:
		'onAddFarmerManuallyFarmerNameInputBoxClick',
	onAddFarmerManuallyMobileNumberInputBoxClick:
		'onAddFarmerManuallyMobileNumberInputBoxClick',
	onAddFarmerManuallyCrossButtonClick: 'onAddFarmerManuallyCrossButtonClick',
	onEditProfileSubmitButtonClick: 'onEditProfileSubmitButtonClick',
	onStartEditProfileScreen: 'onStartEditProfileScreen',

	/* SMS Shop Promotion Screen Start */
	onHomeScreenSmsFeatureIButtonClick: 'onHomeScreenSmsFeatureIButtonClick',
	onHomeScreenSmsFeatureIButtonModalClosedButtonClick:
		'onHomeScreenSmsFeatureIButtonModalClosedButtonClick',
	onSmsDemoVideoClick: 'onSmsDemoVideoClick',
	onSmsDemoVideOkayButtonClick: 'onSmsDemoVideOkayButtonClick',
	onSmsChatWithUsButtonClick: 'onSmsChatWithUsButtonClick',
	onSmsTemplateSelectionClick: 'onSmsTemplateSelectionClick',
	onSmsBalanceButtonClick: 'onSmsBalanceButtonClick',
	onSmsBuyMoreButtonClick: 'onSmsBuyMoreButtonClick',
	onSmsPackBuyButtonClick: 'onSmsPackBuyButtonClick',
	onSmsRechargeProceedButtonClick: 'onSmsRechargeProceedButtonClick',

	/* SMS Shop Promotion Screen End */

	/* SMS Template Screen Start */

	onSmsTemplateBackButtonClick: 'onSmsTemplateBackButtonClick',
	onSmsTemplateEndScreen: 'onSmsTemplateEndScreen',
	onSmsBuyMachineryNotifyFarmerClick: 'onSmsBuyMachineryNotifyFarmerClick',
	onSmsCustomNotifyFarmerClick: 'onSmsCustomNotifyFarmerClick',
	onSmsDiscountNotifyFarmerClick: 'onSmsDiscountNotifyFarmerClick',
	onSmsFertilizerNotifyFarmerClick: 'onSmsFertilizerNotifyFarmerClick',
	onSmsFestivalNotifyFarmerClick: 'onSmsFestivalNotifyFarmerClick',
	onSmsPesticideNotifyFarmerClick: 'onSmsPesticideNotifyFarmerClick',
	onSmsSeedNotifyFarmerClick: 'onSmsSeedNotifyFarmerClick',
	onSmsSellCropNotifyFarmerClick: 'onSmsSellCropNotifyFarmerClick',
	onSmsShopOpenNotifyFarmerClick: 'onSmsShopOpenNotifyFarmerClick',
	onSmsShopOpenMultipleDaysNotifyFarmerClick:
		'onSmsShopOpenMultipleDaysNotifyFarmerClick',
	onSmsThankYouNotifyFarmerClick: 'onSmsThankYouNotifyFarmerClick',
	onSmsBalanceScreenBackButtonClick: 'onSmsBalanceScreenBackButtonClick',

	onUnloadingModalDownloadReceiptButtonClick:
		'onUnloadingModalDownloadReceiptButtonClick',
	onPOReceiptModalDownloadButtonClick: 'onPOReceiptModalDownloadButtonClick',
	onPOReceiptModalCrossButtonClick: 'onPOReceiptModalCrossButtonClick',
	onSaudaBookedOrderDetailCardClick: 'onSaudaBookedOrderDetailCardClick',

	onRemindDriverLocationAccessButtonClick:
		'onRemindDriverLocationAccessButtonClick',

	/* SMS Template Screen End */

	/* Payment Screen start*/
	onPaymentDialogueBoxViewSaudaDetailsClick:
		'onPaymentDialogueBoxViewSaudaDetailsClick',
	onPaymentDialogueBoxCrossButtonClick: 'onPaymentDialogueBoxCrossButtonClick',
	onStartPaymentScreen: 'onStartPaymentScreen',
	onSaudaBookedTruckDetailCardClick: 'onSaudaBookedTruckDetailCardClick',
	/* Payment screen end */

	// TRACKING SCREEN;
	onTruckTrackingDocsAccordionClick: 'onTruckTrackingDocsAccordionClick',
	onTruckTrackingStatusBoxClick: 'onTruckTrackingStatusBoxClick',
	onTruckTrackingAddBuyerGRNButtonClick: 'onTruckTrackingAddBuyerGRNButtonClick',
	onTruckTrackingAddUnloadingWeightSlipButtonClick:
		'onTruckTrackingAddUnloadingWeightSlipButtonClick',
	onSaudaBookedTruckDetailPayableButtonClick:
		'onSaudaBookedTruckDetailPayableButtonClick',
	onSaudaBookedTruckDetailInvoiceNumberButtonClick:
		'onSaudaBookedTruckDetailInvoiceNumberButtonClick',
	onTruckTrackingSubmitButtonClick: 'onTruckTrackingSubmitButtonClick',

	onStartAppLevelFailureScreen: 'onStartAppLevelFailureScreen',
	onAppFailureScreenRetryButtonClick: 'onAppFailureScreenRetryButtonClick',
	onAppFailureScreenHelpButtonClick: 'onAppFailureScreenHelpButtonClick',
	onStartAppBottomFailureModal: 'onStartAppBottomFailureModal',
	onAppBottomFailureModalRetryButtonClick:
		'onAppBottomFailureModalRetryButtonClick',
	onAppBottomFailureModalCrossButtonClick:
		'onAppBottomFailureModalCrossButtonClick',
	//cancel dipatch and unloading modal
	onUnloadingScreenCancelUnloadingBottomModalCancelButtonClick:
		'onUnloadingScreenCancelUnloadingBottomModalCancelButtonClick',
	onUnloadingScreenCancelUnloadingBottomModalNoButtonClick:
		'onUnloadingScreenCancelUnloadingBottomModalNoButtonClick',
};
